<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Asesor Técnico</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <seller-form
          v-if="isDataLoaded"
          :seller="seller"
          :server-errors="serverErrors"
          :title="`Editar Asesor Técnico:${seller.name}`"
          @save="saveSeller"
        ></seller-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import SellerForm from './Forms/SellerForm';
import swal from 'sweetalert2';

export default {
  name: 'SellersEdit',
  components: {
    RouteBreadCrumb,
    SellerForm,
  },

  data() {
    return {
      serverErrors: [],
      isDataLoaded: false,
      seller: null,
    };
  },

  created() {
    const sellerId = this.$route.params.id;
    this.fetchSeller(sellerId);
  },

  methods: {
    fetchSeller(sellerId) {
      let params = {
        include: ['city.province'],
      };

      this.$services
        .resource('sellers')
        .show(sellerId, params)
        .then((res) => res.data.data)
        .then((seller) => {
          this.seller = seller;
          this.isDataLoaded = true;
        });
    },

    saveSeller(seller) {
      this.serverErrors = [];
      this.$services
        .resource('sellers')
        .update(this.seller.id, seller)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El asesor técnico fue actualizado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => {
            if (this.$route.query.redirect) {
              this.$router.push({ path: this.$route.query.redirect });
            } else {
              this.$router.push({ name: 'SellersList' });
            }
          });
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },
  },
};
</script>
